import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

type Tone = 'amber' | 'emerald';

const TONE_CLASSES: Record<Tone, { box: string; icon: string }> = {
  amber: {
    box: 'bg-amber-100 dark:bg-amber-900/30',
    icon: 'text-amber-600 dark:text-amber-400',
  },
  emerald: {
    box: 'bg-emerald-100 dark:bg-emerald-900/30',
    icon: 'text-emerald-600 dark:text-emerald-400',
  },
};

interface CarryStatCardProps {
  icon: LucideIcon;
  tone: Tone;
  title: string;
  value: string | number;
  description: string;
}

export function CarryStatCard({
  icon: Icon,
  tone,
  title,
  value,
  description,
}: CarryStatCardProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center">
            <div className={cn('rounded-lg p-2', TONE_CLASSES[tone].box)}>
              <Icon className={cn('h-5 w-5', TONE_CLASSES[tone].icon)} />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-muted-foreground">
                {title}
              </p>
              <p className="text-2xl font-bold text-foreground">{value}</p>
              <p className="text-xs text-muted-foreground">{description}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
